import { render, staticRenderFns } from "./CounselingAct.vue?vue&type=template&id=bc9332c6"
import script from "./CounselingAct.vue?vue&type=script&lang=js"
export * from "./CounselingAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports